import React from 'react';
import { connect } from 'react-redux';

import { getFormattedFormula, isAbsentCellValue } from '../../../../helpers';
import { IRootState } from '../../../../modules/stores';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string;
}

const Raw: React.FC<{ value: string }> = ({ value }) => (
  <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>
);
const WithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field, locale }) => {
  if (isAbsentCellValue(cell)) return null;

  const value = getFormattedFormula(cell, field.typeOptions, locale);
  if (!value) return null;

  return <Raw value={value}></Raw>;
};

const mapState = ({ core }: IRootState, { recordId, fieldId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
  field: core.fieldById[fieldId],
  locale: core.locale,
});

export default {
  Raw: Raw,
  WithFieldId: connect(mapState)(WithFieldId),
};
